// extracted by mini-css-extract-plugin
export default {"homepage":"UserAuth_homepage__DSdrX","signin":"UserAuth_signin__XJ0Hd","username":"UserAuth_username__WKkhg"};